// extracted by mini-css-extract-plugin
export default {"agentQueueContainer":"AqentQueue_agentQueueContainer__u+gPr","header":"AqentQueue_header__3Z-X7","headerTime":"AqentQueue_headerTime__KockS"};